<template>
  <div id="app">
    <Navbar v-if="$route.name != 'Login'" />
    <Sidebar v-if="$route.name != 'Login'" />
    <notifications group="error" position="top right" />
    <notifications group="success" position="top left" />
    <notifications group="warning" position="top right" />
    <router-view />
  </div>
</template>
<script>
import Navbar from "@/components/admin/navBar.vue";
import Sidebar from "@/components/admin/sideBar.vue";
export default {
  components: {
    Navbar,
    Sidebar
  },
   
  beforeCreate() {
    if (
      this.$cookie.get("adminAuthorization") != null ||
      this.$cookie.get("adminAuthorization") != undefined
    ) {
      this.$root.isLogin = true;
    }
  },
 
};
</script>
<style>
::-webkit-scrollbar {
  display: none;
}
.container-fluid {
  padding-top: 30px !important;
}

</style>
